<template>
	<AppLayout :title="trans('menu.tools.accreditations')" :subtitle="trans('general.search')">
		<div class="flex items-end gap-2">
			<LabeledObject full>
				<template #label>{{ trans('general.search') }}</template>
				<input v-model="searchValue" type="text" @keydown.enter="search">
			</LabeledObject>
			<PrimaryButton :color="Color.Blue" @click.stop="search">
				<i class="fa-solid fa-search"/>
			</PrimaryButton>
		</div>
		<Empty v-if="searchResults.length === 0"/>
		<Card v-for="userResult in searchResults" :key="`user-${userResult.id}`" :title="userResult.full_name" :subtitle="formatNumber(parseInt(userResult.id_number), 0, '', '.')">
			<List>
				<Link
					v-for="accreditable_enrollment in userResult.accreditable_enrollments"
					:key="`enrollment-${accreditable_enrollment.id}`"
					:as="ListItem"
					:title="accreditable_enrollment.event.title"
					:subtitle="accreditable_enrollment.event.colleges.length > 0 ? accreditable_enrollment.event.colleges.map((c:College) => c.name).join(', ') : undefined"
					class="cursor-pointer"
					:href="route('tools.accreditations.enrollments.index', accreditable_enrollment.id)"
				>
					<i class="fa-solid fa-chevron-right text-gray-400 dark:text-gray-600"/>
				</Link>
			</List>
			<p v-if="userResult.accreditable_enrollments.length === 0" class="text-gray-500">{{ trans('general.empty') }}</p>
		</Card>
	</AppLayout>
</template>
<script setup lang="ts">
import axios from 'axios'
import {route} from 'ziggy-js'
import {ref, type Ref} from 'vue'
import {Link} from '@inertiajs/vue3'
import {trans} from 'laravel-vue-i18n'
import {type User} from '@/Types/User'
import {Color} from '@/Types/Enums/Color'
import Empty from '@/Components/UI/Empty.vue'
import Card from '@/Components/UI/Cards/Card.vue'
import List from '@/Components/UI/Lists/List.vue'
import AppLayout from '@/Layouts/AppLayout.vue'
import {type College} from '@/Types/Settings/College'
import ListItem from '@/Components/UI/Lists/ListItem.vue'
import LabeledObject from '@/Components/UI/LabeledObject.vue'
import PrimaryButton from '@/Components/UI/Buttons/PrimaryButton.vue'
import {formatNumber, showInfo, showSuccess, showValidationErrors} from '@/Helpers/general'

const searchValue:Ref<string> = ref('')
const searchResults:Ref<Array<User>> = ref([])

function search():void{
	if(searchValue.value !== null){
		showInfo(trans('general.searching'))
		axios.post(route('tools.accreditations.users'), {
			search: searchValue.value
		}).then(({data}) => {
			searchResults.value = data
			showSuccess(trans('general.shown'))
		}).catch(showValidationErrors)
	}
}
</script>
